import React from 'react';

import { bemBlock } from '../../../modules/bem';
import { Opaque, opaqueClassName } from '../../../modules/decorator';
import { LayoutUnit } from '../../../modules/layout';
import { LayoutFill } from '../../layout-fill/LayoutFill';
import { LayoutRow } from '../../layout-row/LayoutRow';
import { LayoutSeparator } from '../../layout-separator/LayoutSeparator';

import { ToolbarButton } from './ToolbarButton';

import './Toolbar.less';

const block = bemBlock('n-toolbar');

export type ToolbarProps = {
  opaque?: Opaque;
  className?: string;
  withPadding?: 'none' | Extract<LayoutUnit, 'sm'>;
  spacedChildren?: Extract<LayoutUnit, 'xs' | 'sm'>;
  'data-role'?: string;
};

const BaseToolbar: React.FC<ToolbarProps> = ({
  children,
  className,
  opaque,
  spacedChildren = 'sm' as const,
  withPadding = 'sm' as const,
  'data-role': dataRole,
}) => {
  return (
    <LayoutRow
      className={block({
        extra: [className, opaqueClassName(opaque)],
      })}
      spacedChildren={spacedChildren}
      withPadding={withPadding}
      data-role={dataRole}
    >
      {children}
    </LayoutRow>
  );
};

export const Toolbar = Object.assign(BaseToolbar, {
  Button: ToolbarButton,
  Fill: LayoutFill,
  Separator: LayoutSeparator,
});
